import { MeetingStatus, MeetingJoinInfo } from "../../types";

export type AttendeeStatus =
  | "inMeeting"
  | "accepted"
  | "declined"
  | "attended"
  | "missed"
  | "unknown";

export const getAttendeeStatus = (
  meetingStatus: MeetingStatus,
  joinInfo?: MeetingJoinInfo,
): AttendeeStatus => {
  if (!joinInfo) {
    return meetingStatus === MeetingStatus.Ended ? "missed" : "unknown";
  }

  if (
    meetingStatus === MeetingStatus.Scheduled ||
    meetingStatus === MeetingStatus.Started
  ) {
    if (joinInfo.inMeeting) {
      return "inMeeting";
    }

    if (joinInfo.acceptedInvite === true) {
      return "accepted";
    }

    if (joinInfo.acceptedInvite === false) {
      return "declined";
    }

    return "unknown";
  }

  if (meetingStatus === MeetingStatus.Ended) {
    return joinInfo.joinTime ? "attended" : "missed";
  }

  if (meetingStatus === MeetingStatus.Cancelled) {
    return "missed";
  }

  if (meetingStatus === MeetingStatus.Abandoned) {
    return "missed";
  }

  // console.log(meetingStatus, joinInfo);

  return "unknown";
};
